import { AccountResponse } from '@/account/Interfaces';
import { LizanoListProperty } from '@/reports/sections/ListsSection/lists/lists';
import {
  SerializedBulkSearchProperty,
  SerializedBulkSearchData,
} from '@/reports/types/serialized';

export const userAccountStatus = (
  selectedPropertyLength: number,
  currentUser?: AccountResponse
) => {
  const currentUserSubscriptionInfo = currentUser?.account?.subscription_info;
  const isStaff =
    currentUserSubscriptionInfo?.subscription_plan_internal_name ===
    'internal_staff';
  const isUnlimited = currentUserSubscriptionInfo?.['show_unlimited_reports?'];
  const reportsRemaining =
    currentUserSubscriptionInfo?.monthly_reports_remaining;
  const hasEnoughReports = (reportsRemaining ?? 0) >= selectedPropertyLength;
  const notEnoughReportsAndNotStaff = !hasEnoughReports && !isStaff;
  const isUnlimitedAndNotStaff = isUnlimited && !isStaff;

  return {
    reportsRemaining,
    isUnlimitedAndNotStaff,
    notEnoughReportsAndNotStaff,
  };
};

export const serializeSelectedData = (
  data: LizanoListProperty[],
  listCode: string
): SerializedBulkSearchProperty => {
  const typedReport: SerializedBulkSearchData['report_type'] =
    'property_report';
  const typedGenerator: SerializedBulkSearchData['meta']['generator'] = 'bulk';
  const searchData = data
    .map((property) => {
      const { street, city, state, zip5, id } = property;

      return {
        id: `${id}`,
        report_type: typedReport,
        meta: {
          address: street,
          city,
          state,
          zip_code: zip5,
          report_flags: ['use_v3_property_endpoint'],
          generator: typedGenerator,
        },
      };
    })
    .filter((item) => item !== undefined);

  return {
    search_data: searchData,
    options: {
      update_lists_status: true,
      list_code: listCode,
    },
  };
};
